import type { CSSProperties, MouseEvent } from 'react';
import Style from './FJClose.module.less';
import CloseIcon from '../../../assets/modal-close.svg?react';
import classNames from 'classnames';

interface FJCloseProps {
    className?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    style?: CSSProperties;
}

const FJClose = ({ className, onClick, style }: FJCloseProps) => {
    return (
        <div className={classNames(Style.close, className)} onClick={onClick} style={style}>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: 16,
                    background: 'rgba(255,255,255,0.15)',
                }}
            >
                <CloseIcon />
            </div>
        </div>
    );
};

export default FJClose;
